import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import i18next from 'i18next';

const gqlGetCpSubgroups = gql`
  query getCpSubgroups($where: String, $offset: Int, $limit: Int, $order: String) {
    getCpSubgroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
        groupId
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

function useGetSubGroupsLazyQuery() {
  return useLazyQuery(gqlGetCpSubgroups, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

type Props = { groupId?: number } & FsProps;

export const FieldSelectSubGroup = ({
  label = i18next.t('Υποκατηγορία'),
  name = 'subgroupId',
  defaultValues = {},
  groupId = null,
  ...rest
}: Props) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={groupId ? JSON.stringify({ groupId }) : ''}
      // @ts-ignore
      sbLabel={defaultValues?.cpSubgroup?.name ?? undefined}
      hook={useGetSubGroupsLazyQuery}
    />
  );
};

